export class SimexDataProviderDto {
  id: string;
  isEnabled: boolean;
  description: string;
  configuration: string;
  status: string;
}
